import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TokenService } from '../../shared/service/token.service';
import { map, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {
  isBrowser: boolean;
  constructor(
    public snackBar: MatSnackBar,
    public tokenService: TokenService,
    public authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { this.isBrowser = isPlatformBrowser(this.platformId); }

  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    let locale = this.tokenService.getLanguage();
    let locationId: any = this.tokenService.getLocationId();
    const refreshToken = this.tokenService.postWithoutToken();
    if (locale) {
      request = request.clone({ setHeaders: { 'Accept-Language': locale } });
    }
    if (locationId) {
      request = request.clone({ setParams: { locationId: locationId } });
    }
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if ( error?.status === 401) {
          if (error?.error?.error === 'Invalid Token') {
            this.authService
              .refreshToken(refreshToken)
              .subscribe((refreshTokenDetails: any) => {
                if (refreshTokenDetails !== undefined) {
                  this.tokenService.removeToken();
                  this.tokenService.removeRefreshToken();
                  this.tokenService.saveToken(refreshTokenDetails.jwt);
                  this.tokenService.saveRefreshToken(
                    refreshTokenDetails.refreshToken
                  );
                  if(this.isBrowser) {
                    location.reload();
                  }
                }
              });
          } else {
            if(this.isBrowser) {
              sessionStorage.clear();
              if(this.router.url === '/'){
                //do not refresh the page
              }
              else{
                location.reload();
              }
            }
          }
        }
        return throwError(() => error);
      })
    );
  }
}
